import Button from "@components/common/button/Button";
import {Typography, withStyles} from '@material-ui/core';
import * as React from "react";
import TranslateNew from '@translate/TranslateNew';
import {connect} from "react-redux";
import {WithStyles} from "@material-ui/core/styles";
import ProgressBar from "@components/common/progressBar/progressBar";
import {CalendarSyncStyles} from "@components/onboarding/steps/StepCalendarSync/calendarSync.styles";
import {getSelectedFamilyResource} from "@services/user/user.utils";

const tn: TranslateNew = TranslateNew.getInstance();

interface ICalendarSyncProps extends WithStyles<typeof CalendarSyncStyles> {
    nextStep: (customStep?: number) => void;
    progress?: number | undefined;
    classes: any;
    user: any;
    icalToken?: string;
}

interface ICalendarSyncState {
    hasSubscribed: boolean;
}

class CalendarSync extends React.Component<ICalendarSyncProps, ICalendarSyncState> {

    constructor(props: ICalendarSyncProps) {
        super(props);

        this.state = {
            hasSubscribed: false,
        };
    }

    public render() {
        const {classes: style} = this.props;

        return (
            <div className={style.root}>
                <div className={style.background}>
                    <div className={style.circle}/>
                </div>
                <div className={style.container}>
                    {this.props.progress && (<div className={style.topBar}>
                        <ProgressBar value={this.props.progress}/>
                    </div>)}
                    <img alt="" src={require('@images/synkmobil.svg')}/>
                    <div className={style.middleContent}>
                        <Typography variant="h2">{tn.lang.onbSyncTitle}</Typography>
                        <Typography>
                            {tn.lang.onbSyncText}
                        </Typography>
                    </div>
                    <div className={style.bottomContent}>
                        <Button
                            href={"webcal://calendar.varannanvecka.app/v1/ical/" + this.props.icalToken}
                            onClick={() => this.setState({hasSubscribed: true})}
                            variant='contained'
                            color='primary'
                            size="large"
                            fullWidth={true}
                            disabled={this.state.hasSubscribed}
                        >
                            {tn.lang.onbSyncBtnAgree}
                        </Button>
                        <Button
                            variant={this.state.hasSubscribed ? 'contained' : 'text'}
                            color={this.state.hasSubscribed ? 'primary' : undefined}
                            size={this.state.hasSubscribed ? 'large' : undefined}
                            fullWidth={this.state.hasSubscribed}
                            style={{alignSelf: 'center'}}
                            onClick={() => this.props.nextStep()}>
                            {this.state.hasSubscribed ? tn.lang.onbSyncBtnTextDone : tn.lang.onbBtnMaybeLater}
                        </Button>
                    </div>
                </div>
                <div className={style.background}>
                    <div className={style.circle}/>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state: any) {
    return {
        user: state.user.session.data,
        icalToken: getSelectedFamilyResource(state.user.session)?.icalToken,
    };
}

export default connect(mapStateToProps)(withStyles(CalendarSyncStyles)(CalendarSync));



// WEBPACK FOOTER //
// ./src/components/onboarding/steps/StepCalendarSync/calendarSync.component.tsx